module.exports = __webpack_public_path__ + "img/sajilo-class.bb3e3a17.png";